import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Image from '@max/leez-image';
import Text from '@hfe/max-text';
import './Photo.scss';
import { getImage } from '../../utils/common';
function Photo(props) {
    return <View className="comprehensive-card-photo-container">
      <Image className="comprehensive-card-photo-img" source={getImage(props.img)} resizeMode={'cover'} borderRadius={10} heightAuto widthAuto/>
      {props.showTag && <View className="comprehensive-card-photo-tag-container">
          <Text className="comprehensive-card-photo-tag">{props.productTypeName}</Text>
        </View>}

      <Image x-if={props.bottomTag} source={getImage(props.bottomTag)} className="comprehensive-card-photo-bottom-tag-container" style={{
        position: 'absolute'
    }}></Image>
      
      
    </View>;
}
export default memo(Photo);
